/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonAmmoLogInfo,
    JsonAmmoLogInfoFromJSON,
    JsonAmmoLogInfoFromJSONTyped,
    JsonAmmoLogInfoToJSON,
} from './JsonAmmoLogInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonAmmoLogInfo
 */
export interface ApiResultOfJsonAmmoLogInfo {
    /**
     * 
     * @type {JsonAmmoLogInfo}
     * @memberof ApiResultOfJsonAmmoLogInfo
     */
    data?: JsonAmmoLogInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAmmoLogInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonAmmoLogInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAmmoLogInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAmmoLogInfo
     */
    result?: ApiResultOfJsonAmmoLogInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonAmmoLogInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonAmmoLogInfoFromJSON(json: any): ApiResultOfJsonAmmoLogInfo {
    return ApiResultOfJsonAmmoLogInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonAmmoLogInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonAmmoLogInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonAmmoLogInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonAmmoLogInfoToJSON(value?: ApiResultOfJsonAmmoLogInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonAmmoLogInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

